'use client';

import { getUserInfo } from './getUserInfo';

export function getAccessToken(): string | undefined {
  const user = getUserInfo();

  return user.accessToken;
}
